import { useState } from "react";
import { MenuIcon } from "./icons";
import Menu from "./menu";

interface Properties {
  label: string;
  onLabelUpdate: (value: string) => void;
}

const Header: React.FC<Properties> = ({ onLabelUpdate, label }) => {
  const [isMenuActive, setMenuActive] = useState(false);

  return (
    <>
      <div className="mx-6 my-2 flex justify-between">
        <input
          onChange={(e) => onLabelUpdate(e.target.value)}
          value={label}
          className="font-bold text-lg bg-transparent outline-none"
          placeholder="type your items label"
        />
        <MenuIcon
          onClick={() => setMenuActive((status) => !status)}
          className="cursor-pointer"
        />
      </div>
      {isMenuActive && <Menu label={label} />}
    </>
  );
};

export default Header;
